import { QueryKey, useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

import { queryClient } from '../../configs/queryClient';

async function update(axios: AxiosInstance, workshopUpdateRequestId: string | undefined, dataForEndpoint: any): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/service-activity/${workshopUpdateRequestId}/update-vin`, dataForEndpoint);
  return data;
}

export default function useUpdateVinMutation(serviceActivityId: string | undefined, queryKey: QueryKey) {
  const axios = useAxios();

  return useMutation({
    mutationFn: (dataForEndpoint: any) => update(axios, serviceActivityId, dataForEndpoint),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
}
